import { useEffect, useState } from 'react';

/** O valor, só depois de `ms` sem mudar. Evita uma busca por tecla digitada. */
export function useAtrasado<T>(valor: T, ms = 250): T {
  const [atrasado, setAtrasado] = useState(valor);
  useEffect(() => {
    const t = setTimeout(() => setAtrasado(valor), ms);
    return () => clearTimeout(t);
  }, [valor, ms]);
  return atrasado;
}
